import React from "react"
import PropTypes from "prop-types"
import WidgetFrameLayout from './WidgetFrameLayout'

const buttonIdFromUrl = (iframeUrl) => {
  if (!iframeUrl) return null

  try {
    return new URL(iframeUrl).searchParams.get('buttonid')
  } catch (_error) {
    return null
  }
}

const buildUploadWidgetUrl = ({
  buttonId,
  identifier
}) => {
  const params = new URLSearchParams({
    buttonid: buttonId,
    trackid: identifier
  })

  return `/diro/upload-widget?${params.toString()}`
}

const UploadWidget = ({
  iframeUrl,
  onClose,
  externalIdentifier,
  identifier,
  buttonId,
  widgetScriptUrl,
  widgetStylesheetUrl
}) => {
  const resolvedButtonId = buttonId || buttonIdFromUrl(iframeUrl)
  const widgetUrl = resolvedButtonId && identifier ? buildUploadWidgetUrl({
    buttonId: resolvedButtonId,
    identifier
  }) : null

  return(
    <WidgetFrameLayout
      externalIdentifier={externalIdentifier}
      onClose={onClose}
      widgetId="uploadWidget"
    >
      {widgetUrl ? (
        <iframe
          id="bankingWidget"
          title="DIRO upload widget"
          src={widgetUrl}
          sandbox="allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-downloads allow-same-origin"
          className="diro-widget-frame"
        />
      ) : (
        <div className="notification is-danger">Missing DIRO upload button configuration.</div>
      )}
    </WidgetFrameLayout>
  )
}

UploadWidget.propTypes = {
  iframeUrl: PropTypes.string,
  onClose: PropTypes.func,
  externalIdentifier: PropTypes.string,
  identifier: PropTypes.string,
  buttonId: PropTypes.string,
  widgetScriptUrl: PropTypes.string,
  widgetStylesheetUrl: PropTypes.string
}

export default UploadWidget
